import loadable from '@loadable/component';
import { Button } from '@mui/material';
import { Link, Navigate } from 'react-router';
import { OverlaySpinner } from '@ankr.com/ui';

import { Page } from 'modules/layout/components/Page';
import { GlobalMenuWrapper } from 'modules/globalMenu/components/GlobalMenuWrapper';
import { billingRoutesConfig } from 'domains/account/routes';
import { useTranslation } from 'modules/i18n/hooks/useTranslation';
import { BillingAccessGuard } from 'modules/billing/components/BillingAccessGuard';
import { RedirectToAuthPage } from 'modules/auth/components/RedirectToAuthPage';
import { useSignInWithRedirectURL } from 'modules/auth/hooks/useSignInWithRedirectURL';
import { homeRoutesConfig } from 'domains/home/routes';
import { useCurrentPath } from 'modules/common/hooks/useCurrentPath';
import { checkoutRoutesConfig } from 'domains/checkout/routes';

import { useCheckoutPageContainerStyles } from './useCheckoutPageContainerStyles';
import { checkoutPageContainerTranslation } from './checkoutPageContainerTranslation';

const Payments = loadable(() =>
  import('modules/payments/screens/Payments').then(module => module.Payments),
);

const homePath = homeRoutesConfig.home.generatePath();

export const CheckoutPageContainer = () => {
  const { classes } = useCheckoutPageContainerStyles();

  const { keys, t } = useTranslation(checkoutPageContainerTranslation);

  const defaultValues = checkoutRoutesConfig.checkout.useQuery();

  const redirectURL = useCurrentPath();

  const signIn = useSignInWithRedirectURL({
    redirectURL,
  });

  return (
    <div className={classes.checkoutPageContainer}>
      <header className={classes.header}>
        <GlobalMenuWrapper />

        <Button
          component={Link}
          to={billingRoutesConfig.billing.generatePath()}
          variant="text"
          color="secondary"
          className={classes.cancelButton}
        >
          {t(keys.cancel)}
        </Button>
      </header>
      <Page>
        <BillingAccessGuard
          loginFallback={<RedirectToAuthPage customSignIn={signIn} />}
          fallback={<Navigate to={homePath} replace />}
          premissionFallback={<OverlaySpinner />}
        >
          <Payments isCheckoutForm defaultValues={defaultValues} />
        </BillingAccessGuard>
      </Page>
    </div>
  );
};
